import { useWatch } from 'react-hook-form';
import { classNames } from 'utils/classNameUtils';
import Tooltip from 'components/tooltip/Tooltip';
import { Glyphicon } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TextFieldCharacterCounterContainer } from './TextFieldCharacterCounter.styles';

const TextFieldCharacterCounter = ({
  name,
  maxCharacters,
  maxCharactersDescription,
  maxLength,
}: {
  name: string;
  maxCharacters: number;
  maxCharactersDescription?: string;
  maxLength?: number;
}) => {
  const { t } = useTranslation();
  const currentValue = useWatch({ name });
  const currentCount = currentValue?.length || 0;
  const isAbsoluteMax = maxLength === currentCount;

  return (
    <TextFieldCharacterCounterContainer data-testid="character-counter">
      <span
        className={classNames({
          'text-danger': isAbsoluteMax,
          'above-max-characters':
            !isAbsoluteMax && currentCount >= maxCharacters,
        })}
      >
        {t('common.charactersCount', {
          count: currentCount,
        })}
      </span>

      {maxCharactersDescription && (
        <Tooltip
          id="text-field-max-ch-description"
          text={maxCharactersDescription}
        >
          <Glyphicon glyph="info-sign" />
        </Tooltip>
      )}
    </TextFieldCharacterCounterContainer>
  );
};

TextFieldCharacterCounter.defaultProps = {
  maxCharactersDescription: undefined,
  maxLength: undefined,
};

export default TextFieldCharacterCounter;
